import React from "react";
import cn from "classnames";
import "./ChartContainer.scss";
import { InfoTooltip } from "../InfoTooltip";
import { ChartContainerFooter } from "../ChartContainerFooter";

interface ChartContainerProps {
  title: string | React.ReactNode;
  titleAfterDashText?: string;
  leftActions?: React.ReactNode;
  rightActions?: React.ReactNode;
  subHeader?: React.ReactNode;
  enableHoverDesign?: boolean;
  height?: number;
  tooltipText?: string;
  beforeTooltipText?: string;
  rightSideText?: string;
  footerContent?: string | React.ReactNode;
  viewRightActions?: boolean;
  className?: string;
}

const ChartContainer: React.FC<ChartContainerProps> = ({
  title,
  titleAfterDashText,
  leftActions,
  rightActions,
  subHeader,
  enableHoverDesign,
  height,
  tooltipText,
  beforeTooltipText,
  children,
  rightSideText,
  footerContent,
  viewRightActions = false,
  className,
}) => {
  return (
    <div className={cn("chartContainer", { enableHoverDesign }, className)} style={{ height }}>
      <div className="header">
        <div className="mainHeader">
          <div className="leftSide">
            <div className="headerTitle">
              {title}
              {titleAfterDashText && <span className="headerTitleDash">|</span>}
              {titleAfterDashText && (
                <span className="headerTitleDateRange">{titleAfterDashText}</span>
              )}
            </div>
            <div className="leftActions">{leftActions}</div>
          </div>
          <div className={`rightSide ${viewRightActions ? "" : "hidden"}`}>{rightActions}</div>
        </div>
        <div className="subHeader">{subHeader}</div>
      </div>
      <div className="toolTipTextContainer">
        {tooltipText && beforeTooltipText && (
          <div className="leftSideToolTip">
            <div>{beforeTooltipText}</div>
            <InfoTooltip>{tooltipText}</InfoTooltip>
          </div>
        )}
        {!tooltipText && beforeTooltipText && (
          <div className="leftSideToolTip">{beforeTooltipText}</div>
        )}
        {rightSideText && <div className="rightSideToolTip">{rightSideText}</div>}
      </div>
      <div className="contents">{children}</div>
      {footerContent && <ChartContainerFooter content={footerContent} />}
    </div>
  );
};

export default ChartContainer;
